<template>
  <div class="row">
    <!-- {{broadcastParam}}
    <hr />
    {{broadcastParamSt}}-->
    <div class="col-md-12">
      <span class="text-muted">
        Message Type:
        <i class="badge badge-primary" v-if="broadcastParamSt.message.message_type == 'text'">Text Only</i>
        <i class="badge badge-primary" v-else>Media</i>
      </span>

      <div class="row">
        <div class="col-md-8">
          <div class="col-md-12 profile-info-left">
            <div class="col-md-12">
              <Emoji :open="emojiAttr.open" :width="emojiAttr.width" :height="emojiAttr.height"
                searchLabel="Search emoji here" @click="selectedEmoji" />
            </div>
            <div class="col-sm-12 col-md-12">
              <div class="row justify-content-xl-center">
                <div class="col-md-8">
                  <div class="form-group row">
                    <label class="col-form-label" data-tour-step="2.1">Message to send:</label>
                    <!-- {{broadcastParam}} -->
                    <div class="message-bar">
                      <div class="message-inner">
                        <a class="link attach-icon" @click.prevent="emojiToggle()">
                          <img style="width:30px;" src="@/assets/emoji.png" alt />
                        </a>
                        <div class="message-area">
                          <div class="input-group m-b-30">
                            <div class="input-group-prepend">
                              <div class="dropdown dropdown-action">
                                <a href="#" class="action-icon dropdown-toggle text-info" data-toggle="dropdown"
                                  aria-expanded="false">
                                  <i class="material-icons">more_vert</i>
                                </a>
                                <div style="z-index:9999" class="dropdown-menu dropdown-menu-right">
                                  <span style="margin:5px;">
                                    <b>
                                      <u>Template Message:</u>
                                    </b>
                                  </span>
                                  <template v-for="temp in templateMessage">
                                    <a class="dropdown-item" @click.prevent="addTemplateToMesage(temp)"
                                      :key="temp">{{ temp }}</a>
                                  </template>
                                </div>
                              </div>
                            </div>

                            <textarea :style="'height:300px'" ref="messagebox" class="form-control"
                              v-model="broadcastParam.message.text" :placeholder="'Type message...'"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 col-md-4">
                  <div class="row">
                    <div class="col-sm-12">
                      <label data-tour-step="2.2">Interactive Message</label>
                      <div class="onoffswitch">
                        <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox"
                          v-model="broadcastParam.interactive_message_status" id="switch_interactive_message_status" />
                        <label class="onoffswitch-label" for="switch_interactive_message_status">
                          <span class="onoffswitch-inner"></span>
                          <span class="onoffswitch-switch"></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-12" v-if="broadcastParam.interactive_message_status == true">
                      <div class="col-md-12" v-show="false">
                        <div class="form-group">
                          <div class="form-group form-focus select-focus">
                            <select v-model="broadcastParam.interactive_message_type" class="form-control"
                              @change="resetDetailButton">
                              <option :value="''">-- Select --</option>
                              <option v-for="(row, idxBtn) in interactiveMessageTypeList" :key="idxBtn" :value="row.id">
                                {{ row.label }}
                              </option>
                            </select>
                            <label class="focus-label">Button Type</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style="margin-top:10px;" class="col-sm-12"
                      v-if="broadcastParam.interactive_message_status == true">
                    <!-- {{ broadcastParam.buttons }} -->
                      <template>
                        <div v-for="index in defaultDetailTextReply" :key="index" class="col-md-12">
                          <div class="form-group form-focus select-focus">
                            <select v-model="broadcastParam.buttons[(index - 1)]"
                              class="form-control selectTextReply">
                              <option :value="''">-- Select --</option>
                              <template v-for="(row, idxBtn) in textReplyRows" >
                                <option :ref="'text_reply_' + row.id" :value="row">{{ row.title }} </option>
                              </template>
                             
                            </select>
                            <label class="focus-label">Text Reply {{ index }}</label>
                          </div>
                        </div>
                      </template>
                    </div>

                    <div class="col-md-12" v-if="broadcastParam.interactive_message_status == true">
                      <div class="row" v-show="false">
                        <label>Configure Footer Message</label>
                        <div class="onoffswitch">
                          <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox"
                            v-model="broadcastParam.footer_message_status" id="switch_footer_message" />
                          <label class="onoffswitch-label" for="switch_footer_message">
                            <span class="onoffswitch-inner"></span>
                            <span class="onoffswitch-switch"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12"
                      v-if="broadcastParam.footer_message_status == true && broadcastParam.interactive_message_status == true">
                      <div class="form-group">
                        <label>Footer Message:</label>
                        <input maxlength="30" v-model="broadcastParam.footer_message"
                          placeholder="eq: Powered by Waajo.id" type="text" class="form-control" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12" v-if="broadcastParamSt.message.message_type != 'text'">
                  <div class="form-group">
                    <div v-show="files.length == 0 && broadcastParam.is_custom_url == false"
                      class="col-md-12 upload-drop-zone" id="drop-zone">
                      <center>
                        <i class="fa fa-cloud-upload fa-2x"></i>
                        <span class="upload-text">
                          <label :for="name">
                            Just drag and
                            drop file here
                          </label>
                        </span>
                      </center>
                    </div>
                    <div>
                      <!-- <form id="js-upload-form"> -->

                      <div class="col-md-12" v-if="broadcastParam.is_custom_url == true">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group row">
                              <label class="col-form-label">URL File</label>
                              <input type="text" class="form-control" v-model="broadcastParam.message.file_url" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12" v-if="broadcastParam.is_custom_url == false">
                        <!-- {{files}} -->
                        <!-- <h4 v-if="files.length">Uploading</h4> -->
                        <ul class="upload-list" v-if="files.length">
                          <li v-for="file in files" :key="file.id" class="file-list">
                            <div class="upload-wrap">
                              <div class="file-name">
                                <!-- <i class="fa fa-photo"></i> -->
                                <img style="width:30px;" v-if="file.thumb" :src="file.thumb" />
                                {{ file.name }}
                              </div>
                              <div class="file-size">{{ formatSizes(file.size) }}</div>
                              <div class="file-close">
                                <span class="text-danger" v-if="file.error">{{ file.error }}</span>
                                <span v-else-if="file.success">
                                  <i class="text-success fa fa-check-circle"></i>
                                </span>
                                <span v-else-if="file.active">active</span>
                                <span v-else></span>

                                <a href="#" @click.prevent="$refs.uploadbc.remove(file)" class="text-warning">
                                  <i class="fa fa-trash-o"></i>
                                </a>
                              </div>
                            </div>

                            <div class="progress progress-xs progress-striped"
                              v-if="file.active || file.progress !== '0.00'">
                              <div class="progress-bar bg-success" role="progressbar"
                                :style="{ width: file.progress + '%' }"></div>
                            </div>
                            <div class="upload-process" v-if="file.active || file.progress !== '0.00'">
                              {{ file.progress }}% done</div>
                          </li>
                        </ul>
                      </div>
                      <!-- </form> -->

                      <div class="col-sm-12"
                        v-show="($refs.uploadbc && $refs.uploadbc.active == false) && broadcastParam.is_custom_url == false">
                        <div class="submit-section">
                          <div class="input-group mb-3">
                            <div class="input-group-prepend">
                              <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false" v-if="uploadMessageType == ''">Options</button>
                              <button :style="'margin:5px;'" class="btn btn-primary dropdown-toggle" type="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                v-else>{{ uploadMessageType }}</button>
                              <div class="dropdown-menu">
                                <a @click.prevent="updateMessageTypeCurrent(opt)" class="dropdown-item" href="#"
                                  v-for="(opt, index) in messageTypeOptionsUpload" :key="index">
                                  <i class="text-success fa fa-check-circle" v-if="uploadMessageType == opt"></i>
                                  {{ opt }}
                                </a>
                              </div>
                            </div>
                            <div class="input-group-append">
                              <file-upload-bc :add-index="true" class="btn btn-primary" :data="objFilesMessageHandler"
                                :post-action="uploadUrl" :multiple="false" :headers="headers" :drop="true"
                                :drop-directory="true" v-model="files" @input-filter="inputFilter"
                                @input-file="inputFile" ref="uploadbc" :maximum="maximumUpload"
                                :extensions="extensions">
                                <i class="fa fa-plus"></i>
                                Select
                              </file-upload-bc>
                            </div>

                            <!-- <div class="input-group-append">
                            <button
                              v-if="false"
                              @click.prevent="$refs.uploadbc.active = true"
                              class="btn btn-outline-secondary"
                              type="button"
                            >Upload File</button>
                            </div>-->
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-12">
                          <div class="text-muted">
                            <ul style=" overflow-x: scroll;overflow-y: hidden;white-space:nowrap;">
                              <li class="text-wrap">Support files: {{ extensions }}</li>
                              <li>MaxSize: {{ formatSizes(size) }}</li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="row" v-if="$refs.uploadbc && $refs.uploadbc.active == true">
                        <div class="col-sm-2">
                          <Skeleton :height="'40px'" :count="1" />
                        </div>
                        <div class="col-sm-2">
                          <Skeleton :height="'40px'" :count="1" />
                        </div>
                        <div class="col-sm-6">
                          <Skeleton :height="'40px'" :count="1" />
                        </div>
                        <div class="col-sm-2">
                          <Skeleton :height="'40px'" :count="1" />
                        </div>
                      </div>
                    </div>
                    <table class="table borderless">
                      <tr>
                        <th style="width:30%;" class="text-right">Url File</th>
                        <th class="text-left">
                          <div class="onoffswitch">
                            <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox"
                              v-model="broadcastParam.is_custom_url" id="switch_url_file" />
                            <label class="onoffswitch-label" for="switch_url_file">
                              <span class="onoffswitch-inner"></span>
                              <span class="onoffswitch-switch"></span>
                            </label>
                          </div>
                        </th>
                        <th class="text-center">
                          &nbsp;
                          <!-- <label>Select Message Type &amp; Upload File</label>

                          <button
                            class="btn btn-outline-secondary dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            v-if="uploadMessageType==''"
                          >Options</button>
                          <button
                            :style="'margin:5px;'"
                            class="btn btn-outline-secondary dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            v-else
                          >{{uploadMessageType}}</button>
                          <div class="dropdown-menu">
                            <a
                              @click.prevent="updateMessageTypeCurrent(opt)"
                              class="dropdown-item"
                              href="#"
                              v-for="(opt,index) in messageTypeOptionsUpload"
                              :key="index"
                            >
                              <i
                                class="text-success fa fa-check-circle"
                                v-if="uploadMessageType==opt"
                              ></i>
                              {{opt}}
                            </a>
                          </div>-->
                        </th>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="col-md-12">
            <label class="badge badge-dark" data-tour-step="2.3">Preview</label>
          </div>
          <div class="col-md-12" id="preview" :style="'background: url(\'' + whatsappBackground + '\');'">
            <preview-message :textReplyRows="textReplyRows" :buttonsRows="buttonsRows" :linkRows="linkRows" />
          </div>
        </div>
      </div>
    </div>
    <v-tour name="tourGuide2" :steps="tourSteps" :callbacks="tourCallbacks"></v-tour>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

import { Skeleton } from "vue-loading-skeleton";

import { APICore, APICoreV2 } from "@/utils/servicesApi";
import {
  getXAuthAgent,
  getXAuthToken,
  getAgentSession,
  getAuthBasic
} from "@/utils/auth";

import FileUpload from "vue-upload-component";
import Cropper from "cropperjs";
import ImageCompressor from "@xkeshi/image-compressor";
import { VueChatEmoji, emojis } from "vue-chat-emoji";
require("vue-chat-emoji/dist/vue-chat-emoji.min.css");

import { marketplaceIcon, formatSizes } from "@/utils/helper";
import PreviewMessage from "./preview";

export default {
  components: {
    Skeleton,
    FileUploadBc: FileUpload,
    Emoji: VueChatEmoji,
    Carousel,
    Slide,
    PreviewMessage
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      defaultDetailTextReply: 10,
      textReplyRows: [],
      textReplyParams: {
        columnFilters: {
          id: "",
          title: "",
          is_publish: "publish",
        },
        page: 1,
        perPage: 500 // perPage
      },
      tourId: "broadcast.step2",
      tourCallbacks: {
        onSkip: this.tourComplete,
        onFinish: this.tourComplete
      },
      tourSteps: [
        {
          target: '[data-tour-step="2.1"]', // We're using document.querySelector() under the hood
          content: `Teks pesan yang akan dikirim. Support Emoji ataupun Variable.`
        },
        {
          target: '[data-tour-step="2.2"]',
          content: `Pesan dengan opsi Button, List ataupun Link/Call. 
          Untuk menggunakannya pastikan kamu sudah membuat Button ataupun Link/Call  di menu <b>Reply Buttons</b>.
          <br />
          <a target="_blank" href="https://s3-id-jkt-1.kilatstorage.id/aphrodite.enusoft.id/media/static/waajo_button_list_home.png"><img src="https://s3-id-jkt-1.kilatstorage.id/aphrodite.enusoft.id/media/static/waajo_button_list_home.png" style="width:100px;" /></a>
          `
        },
        {
          target: '[data-tour-step="2.3"]',
          content: "Tampilan pesan yang akan dikirim"
        }
      ],
      whatsappBackground: process.env.VUE_APP_WHATSAPP_BACKGROUND,
      uploadMessageType: "image",
      messageTypeOptionsUpload: ["image", "document", "video"],
      broadcastParam: {
        message: {
          text: "",
          message_type: "text", //text,image,document
          file_url: ""
        },
        is_custom_url: false,
        interactive_message_status: false,
        interactive_message_type: "text_reply",
        footer_message_status: false,
        footer_message: "",
        buttons: [{id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}]
      },
      interactiveMessageTypeList: [
        // { id: "button_text", label: "Button" },
        // { id: "action_link", label: "Link/Call" },
        { id: "text_reply", label: "Text Reply" },
        // { id: "list_text", label: "List" }
      ],
      tabMessage: "setup", //setup or preview
      whatsappBackground: process.env.VUE_APP_WHATSAPP_BACKGROUND,
      buttonsLoading: false,
      defaultDetailButton: 10,
      linkParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500 // perPage
      },
      buttonsParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500 // perPage
      },
      linkRows: [],
      buttonsRows: [],
      templateMessage: [
        "${first_name}",
        "${last_name}",
        "${phone_number}",
        "${email}",
        "${month_current}",
        "${month_current_name}",
        "${year_current}",
        "${today}",
        "${yesterday}",
        "${month_ago}",
        "${month_ago_name}",
        "${year_ago}"
      ],
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px"
      },
      objFilesMessageHandler: {
        file: null,
        // message_media: messaegMedia,
        media_type: ""
      },
      assetsUrl: [],
      caption: "",
      name: "file",
      thumbUpload: [],
      uploadAuto: true,
      uploadUrl:
        // process.env.VUE_APP_BASE_API + this.APICore() + "/omni/room/send-file",
        process.env.VUE_APP_BASE_API +
        this.APICore() +
        "/omni/only-upload-filev2",
      maximumUpload: 1,
      accept: "image/jfif,image/png,image/gif,image/jpeg,image/webp",
      extensions: "jfif, gif,jpg,jpeg,png,webp,zip,pdf,xls,xlsx, doc, docx, m4v",
      minSize: 1024,
      size: 1024 * 1024 * 1,
      files: [],
      isLoading: false
    };
  },
  watch: {
    uploadMessageType: {
      handler: function (val, oldVal) {
        if (val != "") {
          this.broadcastParam.message.message_type = val;
        } else {
          this.broadcastParam.message.message_type = "text";
        }

        this.formValidate();
      },
      deep: true
    },
    broadcastParam: {
      handler: function (val, oldVal) {
        // that.broadcastParam.message.message_type =
        //   that.broadcastParamSt.message.message_type;
        this.formValidate();
      },
      deep: true
    },
    broadcastParamSt: {
      handler: async function (val, oldVal) {
        if (val != oldVal) {
          this.broadcastParam = this.broadcastParamSt;
          this.broadcastParam.message.message_type = this.broadcastParamSt.message.message_type;
          this.uploadMessageType = this.broadcastParam.message.message_type;

          // this.assetsUrl = this.formParamScrapeSt.assets_url;
        }
      },
      deep: true
    },

    activeIndex: {
      handler: function (val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          // console.log("active index")
          // this.selectedLicense = [];
          var that = this;
          setTimeout(function () {
            if (val == 1) {
              that.tourDetail();
              // console.log("broadcastParam", that.broadcastParam);
              // // that.broadcastParam = that.broadcastParamSt;
              // console.log("broadcastParam2", that.broadcastParam);

              that.broadcastParam.message.message_type =
                that.broadcastParamSt.message.message_type;
              that.uploadMessageType = that.broadcastParam.message.message_type;

              that.loadTextReply();
              // that.loadReplyButtons();
              // that.loadReplyLink();
            }
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            // that.formPar
            // that.asyncFindProduct();
            // console.log("")
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    broadcastParamSt() {
      return this.$store.state.omniwa.broadcastParamSt;
    },
    detailBroadcast() {
      return this.$store.state.omniwa.detailBroadcast;
    },
    headers() {
      return {
        // Authorization: this.getAuthBasic(),
        "X-Auth-Token": "Bearer " + this.getXAuthToken()
        // "X-Auth-Agent": "Bearer " + this.getXAuthAgent()
      };
    }
  },
  filters: {
    capitalising: function (data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  methods: {
    async loadTextReply() {
      this.buttonsLoading = await true;
      this.textReplyParams.page = 0;
      await this.$store
        .dispatch("automation/listTextReply", this.textReplyParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.textReplyRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    tourShow() {
      this.$tours["tourGuide2"].start();
    },
    tourComplete() {
      let params = {};
      params = {
        tour_id: this.tourId
      };
      this.$store.dispatch("tour/tourComplete", params);
    },
    tourDetail() {
      let params = {};
      params = {
        tour_id: this.tourId
      };
      this.$store.dispatch("tour/tourDetail", params).then(response => {
        var { data } = response;
        if (data.id == "") {
          this.tourShow();
        }
      });
    },
    addTemplateToMesage(template) {
      this.broadcastParam.message.text += template;
    },
    updateMessageTypeCurrent(msgType) {
      this.uploadMessageType = msgType;
    },
    settabMessage(value) {
      this.tabMessage = value;
    },
    resetDetailButton() {
      this.broadcastParam.buttons = [{id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}]

    },
    async loadReplyLink() {
      this.buttonsLoading = await true;
      this.linkParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyLink", this.linkParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.linkRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    async loadReplyButtons() {
      this.buttonsLoading = await true;
      this.buttonsParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyButtons", this.buttonsParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.buttonsRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    emojiToggle(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr.open == true) {
          this.emojiAttr.open = false;
        } else {
          this.emojiAttr.open = true;
        }
      } else {
        this.emojiAttr.open = isClosed;
      }

      if (this.emojiAttr.open == true) {
        this.emojiAttr.width = "96%";
        this.emojiAttr.height = "250px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji(args) {
      this.broadcastParam.message.text += args.emoji;
      this.emojiToggle(false);
      // console.log(args); /* return {...}*/
    },
    inputFileHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.$refs.uploadbc.active = true;
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      console.log("newFile, oldFile", newFile, oldFile);
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }

        // var liContainer = document.getElementById("drag_files");
        // var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal",isShowModal)
        // if (isShowModal == false) {
        //   // document.getElementById("btnDragFiles").click(); // Click on the checkbox
        // }
        // Automatic compression
        // 自动压缩
        if (
          newFile.file &&
          newFile.error === "" &&
          newFile.type.substr(0, 6) === "image/" &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          // console.log("compressing", newFile, oldFile);

          newFile.error = "compressing";
          const imageCompressor = new ImageCompressor(null, {
            convertSize: 1024 * 1024,
            maxWidth: 512,
            maxHeight: 512
          });
          imageCompressor
            .compress(newFile.file)
            .then(file => {
              this.$refs.uploadbc.update(newFile, {
                error: "",
                file,
                size: file.size,
                type: file.type
              });
            })
            .catch(err => {
              this.$refs.uploadbc.update(newFile, {
                error: err.message || "compress"
              });
            });
        }
      }
      console.log("humb newFile, oldFile: ", newFile, oldFile);
      if (
        newFile &&
        newFile.error === "" &&
        newFile.file &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        // 缩略图
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
      // image size
      // image 尺寸
      if (
        newFile &&
        newFile.error === "" &&
        newFile.type.substr(0, 6) === "image/" &&
        newFile.blob &&
        (!oldFile || newFile.blob !== oldFile.blob)
      ) {
        newFile.error = "image parsing";
        let img = new Image();
        img.onload = () => {
          this.$refs.uploadbc.update(newFile, {
            error: "",
            height: img.height,
            width: img.width
          });
        };
        img.οnerrοr = e => {
          console.log("errorr", e);
          this.$refs.uploadbc.update(newFile, { error: "parsing image size" });
        };
        img.src = newFile.blob;
      }
    },
    inputFile(newFile, oldFile) {
      // console.log("inputFile:oldddd", oldFile);
      // console.log("inputFile:newf", newFile);
      if (newFile && oldFile) {
        // console.log("oldddd", oldFile);
        // console.log("newf", newFile);
        // update
        if (newFile.active && !oldFile.active) {
          //buildData
          let dataArr = {
            message_type: this.uploadMessageType
          };
          // this.$store.dispatch("omniwa/actFilesMessageHandler", dataArr);
          this.objFilesMessageHandler = dataArr;
          this.$refs.uploadbc.update(newFile, { data: dataArr });

          // beforeSend
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.uploadbc.update(newFile, { error: "size" });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
          // console.log("progress", newFile.progress);
        }
        if (newFile.error && !oldFile.error) {
          // console.log("err", newFile.error.response);
          // console.log("newFile", newFile);
          this.$refs.uploadbc.update(newFile, { progress: 0 });

          // error
          this.$fire({
            title: "Error",
            text: newFile.response.msg,
            type: "error",
            timer: 1000
          }).then(r => { });
        }
        if (newFile.success && !oldFile.success) {
          this.broadcastParam.message.file_url = newFile.response.data.url;
          // this.caption = "";
          this.thumbUpload.push(newFile.thumb);
          // this.$refs.uploadbc.update(newFile, { progress: 0 });
          // this.$refs.uploadbc.clear();
          // this.$refs.upload.remove(newFile);
          // this.$refs.uploadbc.active = false;

          // success
          // console.log("this.thumbUpload", this.thumbUpload);
          // console.log("success", newFile.success, newFile);
        }
      }
      if (!newFile && oldFile) {
        this.broadcastParam.message.file_url = "";
        // remove
        if (oldFile.success && oldFile.response.id) {
        }
      }
      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.uploadbc.active) {
          this.$refs.uploadbc.active = true;
        }
      }
    },
    formatSizes(bytes) {
      return formatSizes(bytes);
    },
    getExt(filename) {
      return filename.split(".").pop();
    },
    getAuthBasic() {
      return getAuthBasic();
    },

    getXAuthToken() {
      return getXAuthToken();
    },
    getXAuthAgent() {
      return getXAuthAgent();
    },
    messageFilter(message) {
      return message.replace(/\r?\n/g, "<br />");
    },
    APICore() {
      return APICore();
    },
    APICoreV2() {
      return APICoreV2();
    },
    formValidate() {
      let newParam = this.broadcastParamSt;
      newParam.is_custom_url = this.broadcastParam.is_custom_url;
      newParam.message.text = this.broadcastParam.message.text;
      newParam.message.file_url = this.broadcastParam.message.file_url;
      newParam.message.message_type = this.broadcastParam.message.message_type;
      newParam.interactive_message_status = this.broadcastParam.interactive_message_status;
      newParam.interactive_message_type = this.broadcastParam.interactive_message_type;
      newParam.buttons = this.broadcastParam.buttons;
      newParam.footer_message_status = this.broadcastParam.footer_message_status;
      newParam.footer_message = this.broadcastParam.footer_message;
      this.uploadMessageType = this.broadcastParam.message.message_type;

      // newParam.message
      console.log("newparam", newParam);
      this.$store.dispatch("omniwa/actBroadcastParamSt", newParam);
      // console.log("newParamForm2", newParam);
    }
  },
  async created() { },
  beforeDestroy() { },
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "form2-add"
};
</script>


// WEBPACK FOOTER //
// src/views/broadcast/components/form2.vue